import {
    IdentifierRegexResponse,
    IdentifierTypeScope
} from '@/api/resources/common/initialization/common-initialization.dto'
import { store } from '@/store/store'

export class CustomValidationUtils {
    static checkRegex(regexes: IdentifierRegexResponse[], value: string): boolean {
        for (const regex of regexes) {
            const regExp = new RegExp(`^(?:${regex.regex})$`)
            if (regExp.test(value)) {
                return true
            }
        }
        return false
    }

    static checkCaseLabelRegex(value: string): boolean {
        const caseRegexes = store.state.regex.filter(regex => regex.identifierType.idtScope === IdentifierTypeScope.CASE)
        return this.checkRegex(caseRegexes, value)
    }
}
